import React from 'react';
import EventList from './EventList';
import ShopNowConfirm from './ShopNowConfirm';
import EventNotAvailable from './EventNotAvailable';
import EventExpired from './EventExpired';
import ExternalShoppingValidator from 'ViewModels/Shared/ExternalShoppingValidator';

export default class EventsContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            displayComponent: 'EventList',
            selectedEvent: {}
        }
    }

    selectEvent(eventDetail) {
        if (eventDetail.isExpired) {
            this.setState({
                displayComponent: 'EventExpired',
                selectedEvent: eventDetail
            })
            return;
        }

        this.setState({
            displayComponent: 'ShopNowConfirm',
            selectedEvent: eventDetail
        })
    }

    selectExternalEvent(eventDetail) {
        window.location = eventDetail.shopifyLink;
    }


    eventNotAvailable() {
        this.setState({
            displayComponent: 'EventNotAvailable',
            selectedEvent: {}
        });
    }

    backToList() {
        this.setState({
            displayComponent: 'EventList',
            selectedEvent: {}
        })
    }

    render() {
        switch (this.state.displayComponent) {
            case 'EventList':
                return (
                    <EventList {...this.props}
                        selectEvent={this.selectEvent.bind(this)}
                        selectExternalEvent={this.selectExternalEvent.bind(this)}
                        eventNotAvailable={this.eventNotAvailable.bind(this)} />
                );
            case 'ShopNowConfirm':
                return (
                    <ExternalShoppingValidator>
                        <ShopNowConfirm  {...this.props} selectedEvent={this.state.selectedEvent} backToList={this.backToList.bind(this)} />
                    </ExternalShoppingValidator>
                )
            case 'EventExpired':
                return <EventExpired {...this.props} selectedEvent={this.state.selectedEvent} backToList={this.backToList.bind(this)} />
            case 'EventNotAvailable':
                return <EventNotAvailable {...this.props} backToList={this.backToList.bind(this)} />
            default:
                return <EventList {...this.props} selectEvent={this.selectEvent.bind(this)} />
        }
    }
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/Events/EventsContainer.js